import * as React from "react"
import { BadgeCheck, BookOpen, CalendarDays, Flag, Footprints, Home, KeyRound, MapPinned, Palette, Pin, ShipWheel, Users } from "lucide-react"
import { MainNav, type NavItemDef } from "@/components/MainNav"

const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/",
    icon: Home,
    label: "App Home",
    match: () => false,
  },
  {
    href: "/admin/verifications",
    icon: BadgeCheck,
    label: "Verification queue",
    match: (url) => url.startsWith("/admin/verifications") || url === "/admin",
  },
  {
    href: "/admin/problem_reports",
    icon: Flag,
    label: "Problem reports",
    match: (url) => url.startsWith("/admin/problem_reports"),
  },
  {
    href: "/admin/destinations",
    icon: MapPinned,
    label: "Destinations",
    match: (url) => url.startsWith("/admin/destinations"),
  },
  {
    href: "/admin/places",
    icon: Pin,
    label: "Places",
    match: (url) => url.startsWith("/admin/places"),
  },
  {
    href: "/admin/trails",
    icon: Footprints,
    label: "Trails",
    match: (url) => url.startsWith("/admin/trails"),
  },
  {
    href: "/admin/transport_routes",
    icon: ShipWheel,
    label: "Transport",
    match: (url) => url.startsWith("/admin/transport_routes"),
  },
  {
    href: "/admin/guides",
    icon: BookOpen,
    label: "Guides",
    match: (url) => url.startsWith("/admin/guides"),
  },
  {
    href: "/admin/events",
    icon: CalendarDays,
    label: "Events",
    match: (url) => url.startsWith("/admin/events"),
  },
  {
    href: "/admin/users",
    icon: Users,
    label: "Users",
    match: (url) => url.startsWith("/admin/users"),
  },
  {
    href: "/admin/api_tokens",
    icon: KeyRound,
    label: "API tokens",
    match: (url) => url.startsWith("/admin/api_tokens"),
  },
  {
    href: "/admin/design-system",
    icon: Palette,
    label: "Design System",
    match: (url) => url.startsWith("/admin/design-system"),
  },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav items={ADMIN_NAV_ITEMS} brandHref="/admin" />
      <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
        <div className="mx-auto max-w-4xl">{children}</div>
      </main>
    </div>
  )
}
